/** @jsx jsx */
import { jsx } from 'theme-ui'

const RoundedImage = ({ imgUrl, height = 83, width = 83, quality = 85 }) => (
  <img
    loading="lazy"
    sx={{ objectFit: 'cover', height, width, borderRadius: 50 }}
    alt="profile image of a judge"
    src={`${imgUrl}?h=${height * 2}&q=${quality}`}
  />
)

export default RoundedImage
